var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66668 4.39168L2.73334 3.33334L16.6667 17.2667L15.6083 18.3333L13.0417 15.7667C12.0833 16.0833 11.0667 16.25 10 16.25C5.83334 16.25 2.27501 13.6583 0.833344 10C1.40834 8.53334 2.32501 7.24168 3.49168 6.21668L1.66668 4.39168ZM10 7.50001C10.6631 7.50001 11.2989 7.7634 11.7678 8.23224C12.2366 8.70108 12.5 9.33697 12.5 10C12.5004 10.2838 12.4525 10.5656 12.3583 10.8333L9.16668 7.64168C9.4344 7.5475 9.71621 7.49959 10 7.50001ZM10 3.75001C14.1667 3.75001 17.725 6.34168 19.1667 10C18.4862 11.7275 17.3305 13.2269 15.8333 14.325L14.65 13.1333C15.8025 12.3362 16.7319 11.2576 17.35 10C16.6764 8.6249 15.6305 7.46637 14.3311 6.65614C13.0318 5.84591 11.5313 5.41648 10 5.41668C9.09168 5.41668 8.20001 5.56668 7.36668 5.83334L6.08334 4.55834C7.28334 4.04168 8.60834 3.75001 10 3.75001ZM2.65001 10C3.32363 11.3751 4.36956 12.5336 5.66887 13.3439C6.96819 14.1541 8.46877 14.5835 10 14.5833C10.575 14.5833 11.1417 14.525 11.6667 14.4083L9.76668 12.5C9.18681 12.4379 8.6457 12.1791 8.23332 11.7667C7.82095 11.3543 7.56216 10.8132 7.50001 10.2333L4.66668 7.39168C3.84168 8.10001 3.15001 8.98334 2.65001 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.ebf003b5516ca5c7512e4aa5f31c1e2f.svg";
export { ForwardRef as ReactComponent };